<template>
<div>
    <div v-show="!mostrarEventos">
        <b-card no-body>
            <b-card-header>
                <span class="h5">
                    Plano de Trabalho
                </span>
            </b-card-header>
            <b-card-body>
                <div>
                    <app-erros-box
                        :erros="erros"
                        v-if="erros.length > 0"
                    ></app-erros-box>
                    <app-tabela
                        :itens="acoesPlanoTrabalho"
                        :campos="campos"
                        :itensPorPagina="itensPorPagina"
                        :bordered="false"
                        :small="false">
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <btn-inserir-acao-plano-trabalho
                                :convenio="convenio"
                                class="mr-2"
                                :dataServicos="dataServicos"
                                v-if="permiteInserirAtualizarAcoesPlanoTrabalho"
                                @atualizarLista="atualizarLista()">
                            </btn-inserir-acao-plano-trabalho>
                        </b-button-group>
                    </template>
                    <template slot="acoes" slot-scope="data">
                            <btn-atualizar-acao
                                v-if="permiteInserirAtualizarAcoesPlanoTrabalho && data.codSituacao != 1"
                                :convenio="convenio"
                                :acao="data"
                                :dataServicos="dataServicos"
                                @atualizarLista="atualizarLista()">
                            </btn-atualizar-acao>
                            <btn-cancelar-acao
                                v-if="permiteCancelarAcoesPlanoTrabalho && data.codSituacao != 1"
                                class="text-danger float-left mr-1"
                                :convenio="convenio"
                                :acao="data"
                                :dataServicos="dataServicos"
                                @atualizarLista="atualizarLista()"
                            ></btn-cancelar-acao>
                            <btn-mostrar-eventos
                                v-if="temAcessoEventos"
                                @atualizarEvento="eventos = $event"
                                @atualizarConsultoria="consultorias = $event"
                                @atualizarEntrega="entregas = $event"
                                @receberAcao="acao = $event"
                                :acao="data"
                                :dataServicos="dataServicos"
                            ></btn-mostrar-eventos>
                    </template>
                    <template slot="nomeAcao" slot-scope="data">
                            <p class="text-left m-0">
                                {{ data.nomeAcao }}
                            </p>
                        </template>
                        <template slot="nomeGestor" slot-scope="data">
                            <p class="text-left m-0">
                                {{ data.nomeGestor }}
                            </p>
                        </template>
                        <template slot="nomeUnidade" slot-scope="data">
                            <p class="text-left m-0">
                                {{ data.nomeUnidade }}
                            </p>
                        </template>
                        <template slot="situacao" slot-scope="data">
                            <app-status
                                :status="data.situacao.toUpperCase()"
                            ></app-status>
                        </template>
                    </app-tabela>
                </div>
            </b-card-body>
        </b-card>
    </div>
    <div v-if="mostrarEventos">
        <eventos
            :convenio="convenio"
            :acao="acao"
            :eventos="eventos"
            :consultorias="consultorias"
            :entregas="entregas"
            :dataServicos="dataServicos"
            @atualizarAcao="atualizarLista()"
            @voltarAcao="voltarAcao()"
            :temAcessoDocumentosEvento="temAcessoDocumentosEvento"
            :temAcessoConsultoria = "temAcessoConsultoria"
            :temAcessoEntrega="temAcessoEntrega"
            :temAcessoMetas="temAcessoMetas"
            :permiteInserirMetas="permiteInserirMetas"
            :permiteCancelarMetas="permiteCancelarMetas"
            :permiteInserirAtualizarEventos="permiteInserirAtualizarEventos"
            :permiteInserirCancelarDocumentosEvento="permiteInserirCancelarDocumentosEvento"
            :permiteCancelarEventos="permiteCancelarEventos">
        </eventos>
    </div>
</div>
</template>
    
    <script>
import BtnInserirAcaoPlanoTrabalho from '../cadastros/acaoPlanoTrabalho/BtnInserirAcaoPlanoTrabalho'
import BtnCancelarAcao from '../cadastros/acaoPlanoTrabalho/BtnCancelarAcao'
import BtnAtualizarAcao from '../cadastros/acaoPlanoTrabalho/BtnAtualizarAcao'
import BtnMostrarEventos from '../cadastros/acaoPlanoTrabalho/BtnMostrarEventos'
import Eventos from '../cadastros/acaoPlanoTrabalho/eventos/Eventos'

export default {
    components: {
        BtnInserirAcaoPlanoTrabalho,
        BtnCancelarAcao,
        BtnAtualizarAcao,
        BtnMostrarEventos,
        Eventos
    },

    props: {
        dataServicos: {
            type: Object
        },
            convenio: {
                type: Object,
                default: () => ({})
            },
            temAcessoEventos: {
                type: Boolean,
                default: () => false
            },
            temAcessoEntrega: {
                type: Boolean,
                default: () => false
            },
            permiteInserirAtualizarAcoesPlanoTrabalho: {
                type: Boolean,
                default: () => false
            },
            permiteCancelarAcoesPlanoTrabalho: {
                type: Boolean,
                default: () => false
            },
            temAcessoDocumentosEvento: {
                type: Boolean,
                default: () => false
            },
            temAcessoMetas: {
                type: Boolean,
                default: () => false
            },
            temAcessoConsultoria: {
                type: Boolean,
                default: () => false
            },
            permiteInserirMetas: {
                type: Boolean,
                default: () => false
            },
            permiteCancelarMetas: {
                type: Boolean,
                default: () => false
            },
            permiteInserirAtualizarEventos: {
                type: Boolean,
                default: () => false
            },
            permiteCancelarEventos: {
                type: Boolean,
                default: () => false
            },
            permiteInserirCancelarDocumentosEvento: {
                type: Boolean,
                default: () => false
            },
            acoesPlanoTrabalhoConvenio: {
                type: Array,
                default: () => []
            }
        },
        
    

        data() {
            return {
                erros: [],
                eventos: null,
                consultorias: null,
                entregas:null,
                acao:null,
                itensPorPagina: 5,
                acoesPlanoTrabalho: [],
                campos: [
                    {
                        key: 'nomeAcao',
                        label: 'Nome da Ação',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'nomeGestor',
                        label: 'Gestor de Execução',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'nomeUnidade',
                        label: 'Unidade',
                        filterable: true,
                        sortable: true
                    },
                    {
                    key: 'situacao',
                    label: 'Situação',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ]
        }
    },

    methods: {
        atualizarLista() {
            this.$store.dispatch('addRequest')
            this.dataServicos
                .ObterAcoesPlanoTrabalho(this.$route.params.idConvenio)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.acoesPlanoTrabalho = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            },
            atualizarEvento(eventos) {
                this.eventos = eventos
            },
            atualizarConsultoria(consultorias) {
                this.consultorias = consultorias
            },
            atualizarEntregas(entregas) {
                this.entregas = entregas
            },
            receberAcao(acao) {
                this.acao = acao
            },
            voltarAcao(){
                this.eventos = null;
            }
        },
        computed: {
            mostrarEventos() {
                return this.eventos != null
            },
            mostrarConsultorias() {
                return this.consultorias != null
            },
            mostrarEntregas() {
                return this.entregas != null
            }
        },
       
    
    computed: {
        mostrarEventos() {
            return this.eventos != null
        },
        mostrarConsultorias() {
            return this.consultorias != null
        }
    },
    watch: {
        acoesPlanoTrabalhoConvenio() {
            this.acoesPlanoTrabalho = this.acoesPlanoTrabalhoConvenio
        }
    }
}
</script>
    